<template>
    <div
        class="step"
        :class="{ complete: isComplete, active: isActive, 'not-allowed': !clickable }"
        @click="clickable && goToStep()"
    >
        <div class="node">
            <svg
                v-if="isComplete && !isActive"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="12"
                viewBox="0 0 14 12"
                fill="none"
            >
                <path
                    d="M4.44912 9.1786L1.13019 5.75802L0 6.91462L4.44912 11.5L14 1.6566L12.8778 0.5L4.44912 9.1786Z"
                    fill="white"
                />
            </svg>
            <span v-else>
                {{ index + 1 }}
            </span>
        </div>
        <div class="step-title">{{ title }}</div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component()
export default class Step extends Vue {
    @Prop({ type: String })
    title;
    @Prop({ type: Number })
    index;
    @Prop({ type: Number })
    completedStepIndex;
    @Prop({ type: Number })
    activeStepIndex;
    @Prop({ type: Boolean })
    disabled;

    get isComplete() {
        return this.completedStepIndex > this.index;
    }

    get isActive() {
        return this.activeStepIndex === this.index;
    }

    get clickable() {
        if (this.index > this.completedStepIndex) {
            return false;
        }
        return !this.disabled;
    }

    goToStep() {
        this.$emit('changeStep', this.index);
    }
}
</script>
